import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { NosServicesComponent } from './nos-services/nos-services.component';
import { PresentationComponent } from './presentation/presentation.component';
import { ReservationComponent } from './reservation/reservation.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PartenairesComponent } from './partenaires/partenaires.component';
import { ListAvisComponent } from './avis/list-avis/list-avis.component';
import { BackOfficeComponent } from './back-office/back-office.component';
import { AuthGuard } from './auth/auth-services/auth-guard.service';

const routes: Routes = [
    { path: '', component: HomeComponent },
    { path: 'presentation', component: PresentationComponent },
    { path: 'nos-services', component: NosServicesComponent },
    { path: 'reservation', component: ReservationComponent },
    { path: 'nos-partenaires', component: PartenairesComponent },
    { path: 'vos-avis', component: ListAvisComponent },
    { path: 'back-office', canActivate:[AuthGuard], component: BackOfficeComponent },
    { path: 'page-introuvable', component: PageNotFoundComponent },
    { path: '**', redirectTo: "page-introuvable" }
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forRoot(routes,
        { scrollPositionRestoration: 'enabled'}
        )
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }
